import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../services/apiService';
import moment from 'moment';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { pullAt, get, isEqual, sortBy, isEmpty } from 'lodash';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
export default {
  name: 'CoreDtwinRuleTable',
  components: {
    codemirror: codemirror
  },
  props: {
    dtwin: {
      type: Object,
      required: false,
      default: function _default() {}
    },
    // the states that are to be displayed / edited
    value: {
      type: Array,
      required: true
    },
    stateTable: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: false,
      default: false
    },
    hasTwinManagePermission: {
      type: Boolean,
      required: false,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    template: {
      type: Object,
      required: false,
      default: function _default() {}
    },
    isCreatedByTemplate: {
      type: Boolean,
      required: false,
      default: false
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data: function data() {
    return {
      historyQueryStartDate: new Date(new Date() - 86400000 * 5),
      historyQueryEndDate: new Date(),
      ruleEditDialog: false,
      ruleEditServerRequest: false,
      deleteDialog: false,
      targetRuleIndex: -1,
      historyDialog: false,
      copyRuleDialog: false,
      executionHistoryCmdFilter: false,
      executionHistoryRule: {},
      executionHistoryTableOptions: {},
      executionHistory: [],
      executionHistoryItemsLength: -1,
      executionHistoryTableHeaders: [{
        text: this.$i18n_t('Common.date'),
        value: 'date',
        sortable: false
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionConditionResult'),
        value: 'conditionsResult',
        sortable: false
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionConditionChanged'),
        value: 'changed',
        sortable: false
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commands'),
        value: 'commands',
        sortable: false
      }, {
        text: '',
        value: 'data-table-expand'
      }],
      executionHistoryTableFooter: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [15, 30, 50, 100]
      },
      executionHistoryExportDialog: false,
      expandedExecution: [],
      cmOptions: {
        tabSize: 4,
        mode: 'application/ld+json',
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        readOnly: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false,
        viewportMargin: Infinity
      },
      editRuleFormIsValid: false,
      bridgeTypes: [],
      bridgeInstances: [],
      rules: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    detailButtonIcon: function detailButtonIcon() {
      return this.hasTwinEditPermission ? 'fa-edit' : 'fa-eye';
    },
    emptyIndexObject: function emptyIndexObject() {
      // if a twin(state) update comes in, the `value` watcher will fetch all rules again
      // triggering a re-computation of the `core-dtwin-rule-edit`-value field,
      // which defaults to an "empty" object for a new rule
      // to make sure while an edit-dialog is opened no new object is created, put this into a computed prop
      var targetRuleIndex = this.targetRuleIndex;
      return {
        targetRuleIndex: targetRuleIndex
      };
    },
    isTemplateContext: function isTemplateContext() {
      return !isEmpty(this.template);
    },
    buttons: function buttons() {
      return [{
        disabled: this.isProductiveVersion,
        icon: 'fal fa-plus',
        action: 'addItem',
        valid: !this.disabled && this.hasTwinEditPermission,
        tooltip: this.$i18n_t('Common.addNew')
      }];
    }
  }),
  watch: {
    ruleEditDialog: function ruleEditDialog() {
      if (!this.ruleEditDialog) {
        this.targetRuleIndex = this.targetRuleIndex >= 0 ? -1 : this.targetRuleIndex - 1;
      }
    },
    executionHistoryTableOptions: {
      handler: function handler() {
        if (this.executionHistoryRule) {
          this.fetchRuleExecutionHistory(this.executionHistoryRule);
        }
      },
      deep: true
    },
    executionHistoryCmdFilter: function executionHistoryCmdFilter() {
      this.fetchRuleExecutionHistory(this.executionHistoryRule);
    },
    dtwin: function dtwin() {
      this.fetchTwinRules();
    },
    template: function template() {
      this.rules = this.template.ruleDefinition;
    }
  },
  mounted: function mounted() {
    this.fetchTwinRules();

    if (this.isCreatedByTemplate) {
      var indexOfAddBtn = this.buttons.findIndex(function (btn) {
        return btn.action === 'addItem';
      });
      this.buttons[indexOfAddBtn].disabled = true;
    }
  },
  methods: {
    openState: function openState(stateId) {
      var state = this.value.find(function (s) {
        return s.id === stateId;
      });
      this.stateTable.editState(state);
    },
    fetchTwinRules: function fetchTwinRules() {
      var _this = this;

      var bridgeTypesPromise = this.hasTwinEditPermission ? ApiService.getBridgeTypes().then(function (bridgeTypes) {
        return bridgeTypes.filter(function (type) {
          // only display bridges that have instance commands
          return Object.keys(get(type, 'manifest.commands.instance', {})).length > 0;
        });
      }) : Promise.resolve([]);
      var tenantBridgepromise = this.hasTwinEditPermission ? ApiService.getBridgesForTenant(this.isTemplateContext ? this.template.tenantId : this.dtwin.tenantId) : Promise.resolve([]);
      var promises = [bridgeTypesPromise, tenantBridgepromise];

      if (!this.isTemplateContext || this.isCreatedByTemplate) {
        promises.push(ApiService.digitalTwinFetchRules(this, this.dtwin.id));
      }

      return Promise.all(promises).then(function (results) {
        _this.bridgeTypes = results[0];
        _this.bridgeInstances = results[1];

        if (results[2]) {
          _this.rules = results[2].sort(function (a, b) {
            return a.id - b.id;
          });
        } else {
          _this.rules = _this.template.ruleDefinition;
        }

        _this.sanitizeExecutionTimes(_this.rules);

        if (get(_this.$route, 'query.ruleId')) {
          var ruleIndex = _this.rules.findIndex(function (r) {
            return r.id === parseInt(get(_this.$route, 'query.ruleId'));
          });

          if (ruleIndex >= 0) {
            _this.targetRuleIndex = ruleIndex;
            _this.ruleEditDialog = true;
          }
        }
      });
    },
    gatherRuleCommands: function gatherRuleCommands(rule) {
      var _this2 = this;

      return rule.properties.actions.map(function (action) {
        var commandParts = (get(action, 'command') || '').split('.');

        if (commandParts.length === 1) {
          return undefined;
        }

        var bridgeInstanceId = commandParts[0];
        var command = action.command.substring(bridgeInstanceId.length + 1);

        var bridgeInstance = _this2.bridgeInstances.find(function (b) {
          return b.id === parseInt(bridgeInstanceId);
        });

        return "".concat(get(bridgeInstance, 'name') || 'Unknown', ".").concat(command);
      }).filter(function (v) {
        return !!v;
      });
    },
    printRuleExecutionCommands: function printRuleExecutionCommands(execution) {
      var _this3 = this;

      return execution.properties.executedCommands.map(function (commandExec) {
        var bridgeInstanceId = commandExec.bridgeId;
        var command = commandExec.command;

        var bridgeInstance = _this3.bridgeInstances.find(function (b) {
          return b.id === parseInt(bridgeInstanceId);
        });

        return "".concat(get(bridgeInstance, 'name') || 'Unknown', ".").concat(command);
      }).filter(function (v) {
        return !!v;
      }).join(',') || '-';
    },
    addItem: function addItem() {
      this.targetRuleIndex = -1;
      this.ruleEditDialog = true;
    },
    deleteRule: function deleteRule(index) {
      var _this4 = this;

      if (this.rules[index].id) {
        if (this.isTemplateContext) {
          var removedRule = this.template.ruleDefinition[index];
          this.template.ruleDefinition.splice(index, 1);
          ApiService.deviceTemplateUpdate(this.template).then(function () {
            _this4.$emit('update-unsaved-changes', _this4.template);

            _this4.sanitizeExecutionTimes(_this4.rules);

            _this4.$snack(_this4.$i18n_t("DigitalTwin.DigitalTwin.ruleModeler.".concat(removedRule.id ? 'updated' : 'created')) + (removedRule.properties.title || ''), 'success');
          }).catch(function (error) {
            if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
              _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
            } else {
              _this4.$snack(get(error, 'response.data.message') || _this4.$i18n_t('Error.unknown'), 'error');
            }
          });
        } else {
          // TODO: process result
          ApiService.digitalTwinDeleteRule(this, this.dtwin.id, this.rules[index].id);
          pullAt(this.rules, [index]);
          this.rules = cloneDeep(this.rules);
        }
      }
    },
    persistRule: function persistRule(incomingRule) {
      var _this5 = this;

      var rule = this.sanitizeRuleDays(incomingRule);

      if (!this.isTemplateContext) {
        rule.dtwinId = this.dtwin.id;
      }

      var promise = null;
      this.ruleEditServerRequest = true;

      if (this.isTemplateContext) {
        if (rule.id) {
          var ruleIndex = this.template.ruleDefinition.findIndex(function (r) {
            return r.id === incomingRule.id;
          });
          this.template.ruleDefinition[ruleIndex] = rule;
        } else {
          rule.id = rule.properties.title;
          this.rules.push(rule);
        }

        promise = ApiService.deviceTemplateUpdate(this.template).then(function (template) {
          if (incomingRule.id) {
            var index = template.ruleDefinition.findIndex(function (rule) {
              return rule.id === incomingRule.id;
            });
            _this5.rules[index] = template.ruleDefinition[index];
          }

          _this5.sanitizeExecutionTimes(_this5.rules);

          if (incomingRule.id) {
            _this5.rules = cloneDeep(_this5.rules);
          }

          _this5.$emit('update-unsaved-changes', _this5.template);

          _this5.$snack(_this5.$i18n_t("DigitalTwin.DigitalTwin.ruleModeler.".concat(incomingRule.id ? 'updated' : 'created')) + (incomingRule.properties.title || ''), 'success');
        });
      } else {
        if (rule.id) {
          promise = ApiService.digitalTwinUpdateRule(this, rule).then(function (updatedRule) {
            var index = _this5.rules.findIndex(function (r) {
              return r.id === updatedRule.id;
            });

            _this5.rules[index] = updatedRule;

            _this5.sanitizeExecutionTimes(_this5.rules);

            _this5.rules = cloneDeep(_this5.rules);

            _this5.$snack(_this5.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.updated') + (updatedRule.properties.title || ''), 'success');
          });
        } else {
          promise = ApiService.digitalTwinCreateRule(this, rule).then(function (createdRule) {
            _this5.rules.push(createdRule);

            _this5.sanitizeExecutionTimes(_this5.rules);

            _this5.rules = cloneDeep(_this5.rules);

            _this5.$snack(_this5.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.created') + (createdRule.properties.title || ''), 'success');
          });
        }
      }

      promise.catch(function (error) {
        if (_this5.isTemplateContext && !incomingRule.id) {
          _this5.rules.pop();
        }

        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this5.$snack(get(error, 'response.data.message') || _this5.$i18n_t('Error.unknown'), 'error');
        }
      }).finally(function () {
        _this5.ruleEditDialog = false;
        _this5.ruleEditServerRequest = false;
      });
    },
    printRuleStates: function printRuleStates(rule) {
      var _this6 = this;

      if ((rule.stateIds || []).length === 0) {
        return '-';
      }

      return rule.stateIds.filter(function (sid) {
        return !!_this6.value.find(function (s) {
          return s.id === sid;
        });
      }).map(function (sid) {
        return _this6.value.find(function (s) {
          return s.id === sid;
        }).properties.title;
      }).join(', ');
    },
    localizeDate: function localizeDate(date) {
      if (date) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(date).format('L LTS');
      }

      return '-';
    },
    fetchRuleExecutionHistory: function fetchRuleExecutionHistory(rule) {
      var _this7 = this;

      var resetTableOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (resetTableOptions) {
        this.executionHistoryRule = rule; // reset to page 1,

        this.executionHistoryTableOptions = _objectSpread(_objectSpread({}, this.executionHistoryTableOptions), {}, {
          page: 1,
          itemsPerPage: 15
        }); // above will trigger a call to fetchRuleExecutionHistory

        return;
      }

      var _this$executionHistor = this.executionHistoryTableOptions,
          page = _this$executionHistor.page,
          itemsPerPage = _this$executionHistor.itemsPerPage;
      var usedPage = Math.max(1, page || 1);
      var usedItemsPerPage = itemsPerPage || 15;
      var offset = (usedPage - 1) * usedItemsPerPage;
      this.executionHistoryRule = rule;
      ApiService.digitalTwinFetchRuleExecutionHistory(this, rule.dtwinId, rule.id, this.historyQueryStartDate, this.historyQueryEndDate, [this.executionHistoryCmdFilter ? 'commandsonly' : null].filter(function (p) {
        return p;
      }), offset, usedItemsPerPage).then(function (history) {
        _this7.executionHistoryItemsLength = get(history, 'totalCount') || 0;
        _this7.executionHistory = get(history, 'executions') || [];
        _this7.historyDialog = true;
      }).catch(function (error) {
        if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
          _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this7.$snack(get(error, 'response.data.message', _this7.$i18n_t('Common.usersFetchFail')), 'error');
        }
      });
    },
    showExecutionHistoryExportDialog: function showExecutionHistoryExportDialog(rule) {
      this.executionHistoryRule = rule;
      this.executionHistoryExportDialog = true;
    },
    handleDatePicked: function handleDatePicked(dateObject) {
      this.historyQueryStartDate = new Date(dateObject.from * 1000);
      this.historyQueryEndDate = new Date(dateObject.to * 1000);
      this.fetchRuleExecutionHistory(this.executionHistoryRule, true);
    },
    sanitizeRuleDays: function sanitizeRuleDays(incomingRule) {
      var _this8 = this;

      var rule = cloneDeep(incomingRule);
      rule.properties.executionTimes.forEach(function (executionTime) {
        if ((executionTime.weekDays || []).includes(_this8.$i18n_t('Common.AllDays'))) {
          executionTime.weekDays = Array.from({
            length: 7
          }, function (idx, i) {
            return i;
          });
        }

        if ((executionTime.monthDays || []).includes(_this8.$i18n_t('Common.AllDays'))) {
          executionTime.monthDays = Array.from({
            length: 31
          }, function (idx, i) {
            return i + 1;
          });
        }
      });
      return rule;
    },
    sanitizeExecutionTimes: function sanitizeExecutionTimes(rules) {
      var _this9 = this;

      rules.forEach(function (rule) {
        (get(rule, 'properties.executionTimes') || []).forEach(function (executionTime) {
          if (isEqual(sortBy(executionTime.weekDays, function (num) {
            return num;
          }), Array.from({
            length: 7
          }, function (idx, i) {
            return i;
          }))) {
            executionTime.weekDays = [_this9.$i18n_t('Common.AllDays')];
          }

          if (isEqual(sortBy(executionTime.monthDays, function (num) {
            return num;
          }), Array.from({
            length: 31
          }, function (idx, i) {
            return i + 1;
          }))) {
            executionTime.monthDays = [_this9.$i18n_t('Common.AllDays')];
          }
        });
      });
    }
  }
};